import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const BenefitsRow = ({
  title,
  description,
  icon,
  className,
  style
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style }, /* @__PURE__ */ React.createElement("div", { className: cx(styles["box-inner"]) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.left) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.title) }, title), /* @__PURE__ */ React.createElement("div", { className: cx(styles.description) }, description)), /* @__PURE__ */ React.createElement("div", { className: cx(styles.right) }, typeof icon === "string" ? /* @__PURE__ */ React.createElement("img", { src: icon, alt: "" }) : icon)));
BenefitsRow.displayName = "Benefits.Row";

export { BenefitsRow };
//# sourceMappingURL=index.js.map
